import styled from 'styled-components';
export const AuthContainer = styled.div`
    min-height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
    align-items: center;
    background:
        radial-gradient(circle at 10% 10%, rgba(124, 31, 151, 0.18), transparent 45%),
        radial-gradient(circle at 90% 20%, rgba(124, 31, 151, 0.12), transparent 45%),
        linear-gradient(180deg, #fbf7ff 0%, #ffffff 60%);
`;
